<template>
  <section class="main">
    <div
      class="rich-btn"
      :class="{ 'rich-btn_disabled': isDisabled }"
      @click="handleLink"
    >
      {{ btnText }}
    </div>
  </section>
</template>

<script>

export default {
  name: 'ext-info',
  components: {
  },
  inject: ['rootForm'],
  props: {
    btnText: {
      type: String,
      default: ''
    },
    dpListKey: {
      type: Array,
      default: () => [],
    },
    baseLink: {
      type: String,
      default: ''
    },
    linkKeys: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
    }
  },
  computed: {
    isDisabled() {
      const { dpListKey = [] } = this
      return dpListKey.length > 0 && dpListKey.some(chkItem => {
        if (!chkItem.reg.test(this.rootForm.value[chkItem.key])) {
          return true
        }
      })
    },
    linkhref() {
      const { linkKeys = [] } = this
      const { value } = this.rootForm
      const keyValues = linkKeys.map(key => value[key])
      return `${this.baseLink}${keyValues.join("_")}`
    }
  },
  mounted() {
  },
  methods: {
    handleLink() {
      if (!this.isDisabled) {
        window.open(this.linkhref, '_blank')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.main{
  .rich-btn{
    line-height: 2rem;
  }
  .rich-btn_disabled{
    background: #ffd1bf;
  }
}

</style>
